import React from "react";
import { Box, Button, HStack, useDisclosure, VStack } from "@chakra-ui/react";
import { isEmpty } from "lodash-es";
import { Modal } from "components";
import { useCurrentCase } from "duck";
import { getJaw } from "../../../../duck";
import { DentalArcade } from "./components";
import { getAllTeethData } from "./duck";

const QuickView: React.FC = () => {
  const { onClose, onOpen, isOpen } = useDisclosure();

  const { species, dentalChartings, milkOrAdultTeeth } = useCurrentCase(
    ({ data }) => ({
      species: data.client.patient.species || null,
      dentalChartings: data.client.patient.dentalChartings,
      milkOrAdultTeeth:
        data.client.patient.generalAssessment?.dentalChart || null
    })
  );

  const allTeethData = getAllTeethData(dentalChartings);

  const teeth = getJaw(species, milkOrAdultTeeth);

  if (!teeth) {
    return null;
  }

  return (
    <>
      <Button
        isDisabled={isEmpty(allTeethData)}
        onClick={onOpen}
        colorScheme="minor"
      >
        QuickView
      </Button>

      <Modal
        isCentered={false}
        size={{ sm: "2xl", xl: "3xl" }}
        isOpen={isOpen}
        onClose={onClose}
        title="QuickView"
      >
        <VStack spacing={0} align="left">
          <HStack
            align="start"
            mt={2}
            spacing={0}
            borderBottom="1px solid #D0D1D3"
          >
            <Box p="0 24px 24px 0" borderRight="1px solid #D0D1D3" flex={1}>
              <DentalArcade
                arcadeNumber={1}
                title="Upper Right Arcade"
                teethNumbers={teeth}
                allTeethData={allTeethData}
              />
            </Box>
            <Box p="0 0 24px 24px" flex={1}>
              <DentalArcade
                arcadeNumber={2}
                title="Upper Left Arcade"
                teethNumbers={teeth}
                allTeethData={allTeethData}
              />
            </Box>
          </HStack>
          <HStack align="start" pb={2} spacing={0}>
            <Box p="24px 24px 0 0" borderRight="1px solid #D0D1D3" flex={1}>
              <DentalArcade
                arcadeNumber={4}
                title="Lower Right Arcade"
                teethNumbers={teeth}
                allTeethData={allTeethData}
              />
            </Box>
            <Box p="24px 0 0 24px" flex={1}>
              <DentalArcade
                arcadeNumber={3}
                title="Lower Left Arcade"
                teethNumbers={teeth}
                allTeethData={allTeethData}
              />
            </Box>
          </HStack>
        </VStack>
      </Modal>
    </>
  );
};

export default QuickView;
